import React from "react";
import NotFoundContainer from "../../container/notFound";

const SignUpScreen: React.FC<{}> = () => {
    return <NotFoundContainer/>;
}

export default SignUpScreen;